import { render, staticRenderFns } from "./services-lab-hosp.vue?vue&type=template&id=b90245c4"
import script from "./services-lab-hosp.vue?vue&type=script&lang=js"
export * from "./services-lab-hosp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports